import axios from 'axios';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export async function downloadAssessmentReport(app, jobRole) {
  const subId = app.assessmentSubmission.id;

  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/api/assessment/submission/${subId}`
  );
  const data = res.data;

  const rows = (data.questions || []).map((q, i) => {
    const answer = data.answers?.find((a) => a.questionId === q.id)?.answer || 'No answer submitted';
    const ev = data.evaluation?.find((e) => e.questionId === q.id);
    const type = q.type === 'mcq' ? 'MCQ' : q.type === 'coding' ? 'Coding' : 'Short Answer';
    const correct = q.type === 'mcq' && q.correctAnswer ? `\n\nCorrect answer: ${q.correctAnswer}` : '';
    return [
      i + 1,
      `${q.question}\n[${type}]`,
      `${answer}${correct}`,
      ev?.score != null ? `${ev.score}/10` : '--',
      ev?.feedback || '',
    ];
  });

  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.text('Assessment Report', 14, 16);

  autoTable(doc, {
    startY: 22,
    theme: 'grid',
    body: [
      ['Candidate', app.candidateName || data.candidate?.name || '--'],
      ['Email', app.candidateEmail || data.candidate?.email || '--'],
      ['Contact', app.contactNumber || '--'],
      ['Job Role', jobRole || '--'],
      ['Total Exp', app.totalExperience || '--'],
      ['Relevant Exp', app.relevantExperience || '--'],
      ['Present Organization', app.currentCompanyName || '--'],
      ['Notice Period', app.noticePeriod || '--'],
      ['Education', app.education || '--'],
      ['Skills', app.skillSet || '--'],
      ['Overall Score', data.overallScore != null ? `${data.overallScore}/100` : 'Evaluation Pending'],
      ['Submitted At', data.submittedAt ? new Date(data.submittedAt).toLocaleString() : '--'],
    ],
    columnStyles: { 0: { fontStyle: 'bold', cellWidth: 40 } },
  });

  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 8,
    head: [['#', 'Question', 'Answer', 'Score', 'AI Feedback']],
    body: rows,
    styles: { fontSize: 8, cellPadding: 2, overflow: 'linebreak', valign: 'top' },
    headStyles: { fillColor: [37, 99, 235] },
    columnStyles: {
      0: { cellWidth: 8 },
      1: { cellWidth: 50 },
      2: { cellWidth: 52 },
      3: { cellWidth: 15 },
    },
  });

  doc.save(`Assessment_${(app.candidateName || 'candidate').replace(/\s+/g, '_')}.pdf`);
}